export default __webpack_public_path__ + "static/media/converstion-calculator.51c89036.png";